"use client"

import {
  InfiniteTable,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { HeaderRow } from "@/app/components/table"
import type { CollectionOfferGroup } from "@anaconda/core/nft-collection/collection/types"
import { reatomComponent } from "@reatom/react"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useCollectionOfferItemsReatom as useCollectionOfferItems } from "./use-offers-items.reatom"

const COMPONENTS = {
  HeaderRow: OffersHeaderRow,
  RowContent,
  RowSkeleton,
} as const

interface OfferItem {
  offerGroup: CollectionOfferGroup
  bestTotalVolume: string
}

const getItemKey = ({ offerGroup }: OfferItem) => offerGroup.offerPrice.amount

export const OffersTable = reatomComponent(() => {
  const { items, loadNext } = useCollectionOfferItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
      initialItemCount={15}
    />
  )
}, "OffersTable")

export function OffersTableSkeleton() {
  return <TableSkeleton HeaderRow={OffersHeaderRow} RowSkeleton={RowSkeleton} />
}

function OffersHeaderRow() {
  return (
    <HeaderRow>
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: OfferItem }) {
  return (
    <>
      {COLUMNS.map((column, idx) => (
        <Cell key={idx}>
          <column.Content {...content} />
        </Cell>
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}
